// extracted by mini-css-extract-plugin
export default {"form":"AddResolution_form__FbnRw","textArea":"AddResolution_textArea__u87uW","modalContent":"AddResolution_modalContent__DHDYm","formField":"AddResolution_formField__R1Mk0"};